import React from "react";

export default function Skills() {
   return (
      <div>
         <div className="container skills my-5">
            <h2>Skills &amp; Experience</h2>
            <div className="row mt-3">
               <div className="col-md-6 col-12 myskills">
                  <p>html</p>
                  <p> css</p>
                  <p> javascript</p>
                  <p>jquery</p>
                  <p>materialize css</p>
                  <p> bootstrap</p>
                  <p> php</p>
                  <p> mysql</p>
                  <p> react js</p>
                  <p>react native</p>
               </div>
               <div className="col-md-6 col-12">
                  <p>
                     Main area of my expertise is front end development (client
                     side of the web) <br />
                     HTML, CSS, JS, building small and medium web app with React
                     js, mobile application with React native
                     <br /> I also have backend knowledge, I write PHP and used
                     MYSQL as the database.
                  </p>
                  <div id="mark" />
               </div>
            </div>
         </div>
      </div>
   );
}
